import { fKeyTabInput } from "../../../Utility/Utilitys";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GcContent({
  xBufferObj = {},
  xErrorMsgDetail = {},
  xMediaQuery = false,
  onChnage = () => {},
  fUnit = () => {},
  sUnit = [],
  fBatch=() => {},
  fBatchEnter=() => {},
  fQty_Enter=() => {},
  xContent_Focus,
          xContent_Blur,
          BarcodeFocusOnLoad
}) {
  return (
    <form
      className="Wms-inbound-grn-content mt-4"
      id="WmsStockAdjustmentContent"
    >
      <Grid
        container
        spacing={{ xs: 1, sm: 0.5, md: 1}}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        {!xMediaQuery && (
          <Grid item xs={6} sm={1} md={1} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="S.No"
              xValue={xBufferObj?.DP_SrNo}
              xType={"text"} // text/number/password
              xName={"DP_SrNo"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail?.DP_SrNo === "" ? false : true}
              xErrorMessage={xErrorMsgDetail?.DP_SrNo}
              // xOnKeyUp={xKey}
            />
          </Grid>
        )}
        <Grid item xs={8} sm={2} md={3} className="lastkeyDetect">
          <GCToggleSearchV1
          xref={BarcodeFocusOnLoad}
           xLabelText="Batch"
            xtabIndex={"101"}
            xName={"DP_Batch"}
            xType={"text"}
            xValue={xBufferObj?.DP_Batch}
            xReadOnly={false}
            xOnChange={fBatch}
            xOnKeyUp={fBatchEnter}
            xError={xErrorMsgDetail?.DP_Batch === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.DP_Batch}
            xMediaQuery={xMediaQuery}
            xonClickbtn={fBatchEnter}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={xBufferObj?.DP_ItmCd}
            xType={"text"} // text/number/password
            xName={"DP_ItmCd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail?.DP_ItmCd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.DP_ItmCd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid item xs={8} sm={4} md={4} lg={3} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Name"
            xValue={xBufferObj?.ItmName}
            xType={"text"} // text/number/password
            xName={"ItmName"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail?.ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.ItmName}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Batch Qty"
            xValue={xBufferObj?.BacthQty}
            xType={"number"} // text/number/password
            xName={"BacthQty"}
             xReadOnly={true}
            xOnChange={()=>{}}
            xError={xErrorMsgDetail?.BacthQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.BacthQty}
            // xonFocus={(e) => {
            //   xContent_Focus(e);
            // }}
            // xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Res.Qty"
            xValue={xBufferObj?.ResQty}
            xType={"number"} // text/number/password
            xName={"ResQty"}
             xReadOnly={true}
            xOnChange={()=>{}}
            xError={xErrorMsgDetail?.ResQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.ResQty}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Bal.Qty"
            xValue={xBufferObj?.BalQty}
            xType={"number"} // text/number/password
            xName={"BalQty"}
             xReadOnly={true}
            xOnChange={()=>{}}
            xError={xErrorMsgDetail?.BalQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.BalQty}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Trans.Qty"
            xValue={xBufferObj?.TransQty}
            xType={"number"} // text/number/password
            xName={"TransQty"}
             xReadOnly={true}
            xOnChange={()=>{}}
            xError={xErrorMsgDetail?.TransQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.TransQty}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Alloc.Qty"
            xValue={xBufferObj?.AllocQty}
            xType={"number"} // text/number/password
            xName={"AllocQty"}
             xReadOnly={true}
            xOnChange={()=>{}}
            xError={xErrorMsgDetail?.AllocQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.AllocQty}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Bal.Qty"
            xValue={xBufferObj?.BalalanceQty}
            xType={"number"} // text/number/password
            xName={"BalQty"}
             xReadOnly={true}
            xOnChange={()=>{}}
            xError={xErrorMsgDetail?.BalalanceQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.BalalanceQty}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
                      xtabIndex={"102"}
            xLabelText="Qty"
            xValue={xBufferObj?.DP_Qty}
            xType={"number"} // text/number/password
            xName={"DP_Qty"}
            xReadOnly={false}
            xOnChange={onChnage}
            xError={xErrorMsgDetail?.DP_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.DP_Qty}
            xOnKeyUp={fQty_Enter}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={8} sm={2} md={2} className="lastkeyDetect">
           
          <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={xBufferObj?.DP_Unit}
            xOnChange={fUnit}
            xName={"DP_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail?.DP_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.DP_Unit}
          />
        </Grid>

        <Grid item  xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="BaseQty"
            xValue={xBufferObj?.DP_BaseQty}
            xType={"text"} // text/number/password
            xName={"DP_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail?.DP_BaseQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail?.DP_BaseQty}
            // xOnKeyUp={xKey}
          />
        </Grid>
      </Grid>
    </form>
  );
}
